"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.asyncReducer = function (fn) {
    return function (state, action) {
        if (state === void 0) { state = {}; }
        switch (action.type) {
            case String(fn.pending):
                return tslib_1.__assign({}, state, { pending: true });
            case String(fn.fulfilled):
                return tslib_1.__assign({}, state, { data: action.payload, error: undefined, pending: false });
            case String(fn.rejected):
                return tslib_1.__assign({}, state, { error: action.payload, pending: false });
            default:
                return state;
        }
    };
};
//# sourceMappingURL=reducers.js.map